import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

const DICT = {
  pt: {
    "brand.suffix": "Online",
    "nav.new_invoice": "Nova Fatura",
    "nav.login": "Entrar",
    "nav.history": "Histórico",
    "role.accountant": "Contabilista",
    "role.client": "Cliente",
    "common.back": "Voltar",
    "common.loading": "A carregar…",
    "common.saving": "A guardar…",
    "common.new_invoice": "Nova fatura",
    "common.messages": "Mensagens",
    "common.vendor_unknown": "Fornecedor por identificar",

    "status.pending": "Em análise",
    "status.processed": "Processada",
    "status.processed_plural": "Processadas",
    "status.error": "Com erro",

    "landing.eyebrow": "perfinco · online — exclusivo para clientes",
    "landing.title_1": "Envie a sua fatura à",
    "landing.title_brand": "Perfinco",
    "landing.title_2": "Numa",
    "landing.title_emphasis": "fotografia",
    "landing.subtitle": "A Perfinco Online é a forma mais rápida de fazer chegar faturas à nossa equipa de contabilistas. A nossa IA lê os dados da fatura. Você só tem de fotografar ou reencaminhar um email.",
    "landing.cta_invite": "Entrar com convite Perfinco",
    "landing.cta_request": "Pedir acesso",
    "landing.feature_capture": "Captura rápida",
    "landing.feature_capture_desc": "Foto da fatura, envio imediato.",
    "landing.feature_ai": "IA portuguesa",
    "landing.feature_ai_desc": "NIF, total e data extraídos.",
    "landing.feature_private": "Privado",
    "landing.feature_private_desc": "Acesso restrito pela equipa da Perfinco.",
    "landing.how_title": "Como funciona",
    "landing.step_label": "passo",
    "landing.ai_detected": "Detetado pela IA",
    "landing.step1_title": "Fotografa",
    "landing.step1_desc": "Abre a app, toca em Nova Fatura e tira uma fotografia.",
    "landing.step2_title": "IA lê os dados",
    "landing.step2_desc": "Em segundos, valores e fornecedor surgem prontos.",
    "landing.step3_title": "Perfinco trata",
    "landing.step3_desc": "A nossa equipa valida e contabiliza para si.",
    "landing.footer_tagline": "Contabilidade e Consultoria Financeira",

    "login.eyebrow": "entrar",
    "login.title": "Bem-vindo de volta",
    "login.email": "Email",
    "login.password": "Palavra-passe",
    "login.submit": "Entrar",
    "login.or": "ou",
    "login.google": "Entrar com Google",
    "login.submitting": "A entrar…",
    "login.no_account": "Ainda não tem conta? Peça à equipa Perfinco que lhe envie um convite.",

    "cd.eyebrow": "o meu portal",
    "cd.title": "As minhas faturas",
    "cd.stat_total": "Total",
    "cd.empty_title": "Ainda sem faturas",
    "cd.empty_desc": "Tire uma foto à sua primeira fatura e envie em segundos.",

    "up.invalid_format": "Formato inválido. Use JPEG, PNG ou WEBP.",
    "up.eyebrow": "nova fatura",
    "up.title": "Tire uma foto à fatura",
    "up.subtitle": "Use a câmara ou escolha uma imagem do dispositivo. Tratamos do resto.",
    "up.no_image": "Sem imagem selecionada",
    "up.take_photo": "Tirar foto",
    "up.choose_file": "Escolher ficheiro",
    "up.uploading": "A enviar e a analisar…",
    "up.submit": "Enviar fatura",
    "up.uploading_hint": "A IA está a ler a fatura. Pode demorar uns segundos.",
    "up.email_eyebrow": "ou por email",
    "up.email_title": "Reencaminhe por email",
    "up.email_desc": "Recebeu a fatura por email? Reencaminhe-a para o endereço abaixo, a partir do seu email registado, e nós tratamos do resto.",
    "up.email_unavailable": "A receção por email ainda não foi ativada pela Perfinco.",
    "up.email_from_note": "Reencaminhe a partir de:",
    "up.copy": "Copiar",
    "up.copied": "Copiado!",
    "source.email": "Email",
    "source.upload": "Foto",

    "inv.eyebrow": "convite",
    "inv.invalid": "Convite inválido",
    "inv.validating": "A validar convite…",
    "inv.welcome": "Bem-vindo,",
    "inv.desc": "A Perfinco convidou-o(a) para começar a usar a app. Crie a sua palavra-passe abaixo.",
    "inv.your_name": "O seu nome",
    "inv.password": "Palavra-passe (mín. 6)",
    "inv.creating": "A criar conta…",
    "inv.submit": "Aceitar e entrar",

    "id.eyebrow": "fatura",
    "id.received": "Recebida",
    "id.loading_image": "A carregar imagem…",
    "id.ai_data": "dados extraídos pela IA",
    "id.reextract": "Re-extrair",
    "id.vendor": "Fornecedor",
    "id.invoice_number": "Nº fatura",
    "id.invoice_date": "Data fatura",
    "id.total": "Total",
    "id.currency": "Moeda",
    "id.extract_error": "Erro na extração:",
    "id.control": "controlo",
    "id.internal_notes": "Notas internas",
    "id.notes_placeholder": "Observações para a equipa…",
    "id.save_notes": "Guardar notas",
    "id.accountant_notes": "notas do contabilista",

    "msg.no_company": "Sem empresa associada à sua conta.",
    "msg.eyebrow": "mensagens",
    "msg.team": "Equipa Perfinco",
    "msg.empty": "Sem mensagens. Comece a conversa abaixo.",
    "msg.sender_client": "Cliente",
    "msg.normal": "Normal",
    "msg.high": "Prioritário",
    "msg.urgent": "Urgente",
    "msg.placeholder": "Escreva uma mensagem…",
    "msg.send": "Enviar",
    "msg.attach": "Anexar ficheiro (imagem ou PDF)",
    "msg.priority": "Prioridade",
    "cd.filter_month": "Mês",
    "cd.filter_all_months": "Todos os meses",
    "cd.filter_status": "Estado",
    "cd.filter_all_status": "Todos",
    "cd.sum": "Soma valores",
    "cd.calendar": "Calendário fiscal",
    "cd.reminders": "Obrigações fiscais nos próximos 7 dias",
    "cd.no_company": "A sua conta ainda não está associada a uma empresa. Contacte a Perfinco para começar a usar o calendário fiscal.",
    "pay.title": "Pagamento",
    "pay.paid": "Fatura paga",
    "pay.method": "Método",
    "pay.date": "Data de pagamento",
    "pay.note": "Nota (opcional)",
    "pay.note_ph": "Ex.: pago por transferência da conta principal",
    "pay.save": "Guardar pagamento",
    "pay.none": "Sem informação de pagamento.",
    "pay.not_paid": "Por pagar",
    "pay.m.transferencia": "Transferência bancária",
    "pay.m.mbway": "MB Way",
    "pay.m.debito_direto": "Débito direto",
    "pay.m.numerario": "Numerário",
    "pay.m.cartao": "Cartão",
    "pay.m.multibanco": "Ref. Multibanco",
    "pay.m.socio": "Sócio",
    "pay.m.outro": "Outro",
    "fc.title": "Calendário fiscal",
    "fc.eyebrow": "obrigações fiscais",
    "fc.regime": "Regime de IVA",
    "fc.monthly": "Mensal",
    "fc.quarterly": "Trimestral",
    "fc.company": "Empresa",
    "fc.upcoming": "Próximas obrigações",
    "fc.disclaimer": "Datas legais de referência. Podem variar com dias úteis e feriados — confirme sempre com a Perfinco.",
    "fc.empty": "Selecione uma empresa para ver o calendário fiscal.",
    "fc.prev": "Anterior",
    "fc.next": "Seguinte",
    "fc.no_events": "Sem obrigações fiscais neste mês.",
  },
  en: {
    "brand.suffix": "Online",
    "nav.new_invoice": "New Invoice",
    "nav.login": "Sign in",
    "nav.history": "History",
    "role.accountant": "Accountant",
    "role.client": "Client",
    "common.back": "Back",
    "common.loading": "Loading…",
    "common.saving": "Saving…",
    "common.new_invoice": "New invoice",
    "common.messages": "Messages",
    "common.vendor_unknown": "Vendor not identified",

    "status.pending": "Under review",
    "status.processed": "Processed",
    "status.processed_plural": "Processed",
    "status.error": "Error",

    "landing.eyebrow": "perfinco · online — clients only",
    "landing.title_1": "Send your invoice to",
    "landing.title_brand": "Perfinco",
    "landing.title_2": "In one",
    "landing.title_emphasis": "photo",
    "landing.subtitle": "Perfinco Online is the fastest way to get invoices to our accounting team. Our AI reads the invoice data. You just take a photo or forward an email.",
    "landing.cta_invite": "Sign in with Perfinco invite",
    "landing.cta_request": "Request access",
    "landing.feature_capture": "Quick capture",
    "landing.feature_capture_desc": "Photo of the invoice, sent instantly.",
    "landing.feature_ai": "Portuguese AI",
    "landing.feature_ai_desc": "Tax ID, total and date extracted.",
    "landing.feature_private": "Private",
    "landing.feature_private_desc": "Access restricted by the Perfinco team.",
    "landing.how_title": "How it works",
    "landing.step_label": "step",
    "landing.ai_detected": "Detected by AI",
    "landing.step1_title": "Take a photo",
    "landing.step1_desc": "Open the app, tap New Invoice and take a photo.",
    "landing.step2_title": "AI reads the data",
    "landing.step2_desc": "In seconds, amounts and vendor are ready.",
    "landing.step3_title": "Perfinco handles it",
    "landing.step3_desc": "Our team validates and accounts it for you.",
    "landing.footer_tagline": "Accounting and Financial Consulting",

    "login.eyebrow": "sign in",
    "login.title": "Welcome back",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign in",
    "login.or": "or",
    "login.google": "Sign in with Google",
    "login.submitting": "Signing in…",
    "login.no_account": "Don't have an account? Ask the Perfinco team to send you an invite.",

    "cd.eyebrow": "my portal",
    "cd.title": "My invoices",
    "cd.stat_total": "Total",
    "cd.empty_title": "No invoices yet",
    "cd.empty_desc": "Take a photo of your first invoice and send it in seconds.",

    "up.invalid_format": "Invalid format. Use JPEG, PNG or WEBP.",
    "up.eyebrow": "new invoice",
    "up.title": "Take a photo of the invoice",
    "up.subtitle": "Use the camera or pick an image from your device. We handle the rest.",
    "up.no_image": "No image selected",
    "up.take_photo": "Take photo",
    "up.choose_file": "Choose file",
    "up.uploading": "Uploading and analysing…",
    "up.submit": "Send invoice",
    "up.uploading_hint": "The AI is reading the invoice. This may take a few seconds.",
    "up.email_eyebrow": "or by email",
    "up.email_title": "Forward by email",
    "up.email_desc": "Received the invoice by email? Forward it to the address below, from your registered email, and we'll take care of the rest.",
    "up.email_unavailable": "Email reception hasn't been enabled by Perfinco yet.",
    "up.email_from_note": "Forward from:",
    "up.copy": "Copy",
    "up.copied": "Copied!",
    "source.email": "Email",
    "source.upload": "Photo",

    "inv.eyebrow": "invite",
    "inv.invalid": "Invalid invite",
    "inv.validating": "Validating invite…",
    "inv.welcome": "Welcome,",
    "inv.desc": "Perfinco has invited you to start using the app. Create your password below.",
    "inv.your_name": "Your name",
    "inv.password": "Password (min. 6)",
    "inv.creating": "Creating account…",
    "inv.submit": "Accept and sign in",

    "id.eyebrow": "invoice",
    "id.received": "Received",
    "id.loading_image": "Loading image…",
    "id.ai_data": "data extracted by AI",
    "id.reextract": "Re-extract",
    "id.vendor": "Vendor",
    "id.invoice_number": "Invoice no.",
    "id.invoice_date": "Invoice date",
    "id.total": "Total",
    "id.currency": "Currency",
    "id.extract_error": "Extraction error:",
    "id.control": "control",
    "id.internal_notes": "Internal notes",
    "id.notes_placeholder": "Notes for the team…",
    "id.save_notes": "Save notes",
    "id.accountant_notes": "accountant notes",

    "msg.no_company": "No company linked to your account.",
    "msg.eyebrow": "messages",
    "msg.team": "Perfinco Team",
    "msg.empty": "No messages. Start the conversation below.",
    "msg.sender_client": "Client",
    "msg.normal": "Normal",
    "msg.high": "Priority",
    "msg.urgent": "Urgent",
    "msg.placeholder": "Write a message…",
    "msg.send": "Send",
    "msg.attach": "Attach file (image or PDF)",
    "msg.priority": "Priority",
    "cd.filter_month": "Month",
    "cd.filter_all_months": "All months",
    "cd.filter_status": "Status",
    "cd.filter_all_status": "All",
    "cd.sum": "Total amount",
    "cd.calendar": "Tax calendar",
    "cd.reminders": "Tax obligations in the next 7 days",
    "cd.no_company": "Your account is not yet linked to a company. Contact Perfinco to start using the tax calendar.",
    "pay.title": "Payment",
    "pay.paid": "Invoice paid",
    "pay.method": "Method",
    "pay.date": "Payment date",
    "pay.note": "Note (optional)",
    "pay.note_ph": "E.g.: paid by transfer from the main account",
    "pay.save": "Save payment",
    "pay.none": "No payment information.",
    "pay.not_paid": "Unpaid",
    "pay.m.transferencia": "Bank transfer",
    "pay.m.mbway": "MB Way",
    "pay.m.debito_direto": "Direct debit",
    "pay.m.numerario": "Cash",
    "pay.m.cartao": "Card",
    "pay.m.multibanco": "MB reference",
    "pay.m.socio": "Partner",
    "pay.m.outro": "Other",
    "fc.title": "Tax calendar",
    "fc.eyebrow": "tax obligations",
    "fc.regime": "VAT regime",
    "fc.monthly": "Monthly",
    "fc.quarterly": "Quarterly",
    "fc.company": "Company",
    "fc.upcoming": "Upcoming obligations",
    "fc.disclaimer": "Reference legal dates. They may vary with working days and holidays — always confirm with Perfinco.",
    "fc.empty": "Select a company to view the tax calendar.",
    "fc.prev": "Previous",
    "fc.next": "Next",
    "fc.no_events": "No tax obligations this month.",
  },
};

const I18nCtx = createContext({ lang: "pt", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("perfinco_lang");
    if (saved === "pt" || saved === "en") return saved;
    const nav = (navigator.language || navigator.userLanguage || "pt").toLowerCase();
    return nav.startsWith("pt") ? "pt" : "en";
  });
  useEffect(() => {
    localStorage.setItem("perfinco_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = useCallback((l) => setLangState(l === "en" ? "en" : "pt"), []);
  const t = useCallback((k) => (DICT[lang] && DICT[lang][k]) || DICT.pt[k] || k, [lang]);
  return <I18nCtx.Provider value={{ lang, t, setLang }}>{children}</I18nCtx.Provider>;
}

export const useT = () => useContext(I18nCtx);
